module.exports = __webpack_public_path__ + "media/images/emblems/Jenaz_wappen-a04731b28479e84bac2e5b5874cef3d2.svg";